export default __webpack_public_path__ + "static/media/footer_collaborators@2x.08ffb2e4.png";